import { Column2 } from "@/ui2/atoms/(table)/Column";
import { TableHeader2 } from "@/ui2/molecules/(table)/TableHeader";

export function CseTableHeader() {
  return (
    <TableHeader2>
      {TABLE_HEADER_ITEMS.map((header, index) => (
        <Column2 id={header.id} isRowHeader={index === 0} key={header.id}>
          {header.label}
        </Column2>
      ))}
    </TableHeader2>
  );
}

type TableHeaderItem = {
  id: string;
  label: string;
};

const TABLE_HEADER_ITEMS = [
  { id: "name", label: "Name" },
  { id: "email", label: "Email Address" },
  { id: "mobile", label: "Phone Number" },
  { id: "status", label: "Status" },
  { id: "action", label: "Action" },
] satisfies TableHeaderItem[];
